import { Paginator } from '@app/classes';
import { Table } from '@app/modules/table/classes/table.class';
import { AuthService } from '@app/services';
import {
    DepartmentColumn,
    FullNameColumn,
    HiredAtColumn,
    PositionColumn,
    StatusColumn,
} from '@employees/services/tables/employee-table/columns';
import { Employee } from '@models/employee/employee.model';

export class EmployeesIndexTable extends Table {
    links = true;
    protected allowedStatuses: string[] = ['active'];

    // Don't change this without consulting a PM. The default sort ordering the backend is what we want
    // HR-815 don't change sorting or filters without consulting product managers
    protected defaultSortProperty = null;

    constructor(protected auth: AuthService) {
        super(auth);
        this.allowedStatuses = this.getStatusFilterOptionsFromPermissions();
        this.boot();
    }

    setColumns(): void {
        const companyId = this.auth.company.id;
        const nameColumn = new FullNameColumn();

        this.columns = [];

        const columns = [nameColumn, new PositionColumn(companyId)];

        if (this.allowedStatuses.length > 1) {
            const statusColumn = new StatusColumn();
            statusColumn.changeFilters(this.allowedStatuses);
            columns.push(statusColumn);
        }

        columns.push(new DepartmentColumn(companyId), new HiredAtColumn());

        this.addColumns(...columns);
    }

    setDataSource(): void {
        const query = Employee.param('company', this.auth.company.id).with(['account', 'department', 'job']);

        this.paginator = new Paginator(
            // HR-815 don't change sorting or filters without consulting product managers
            this.auth.isAdmin() ? query : query.where('status', 'active')
        );
    }

    private getStatusFilterOptionsFromPermissions(): string[] {
        const statuses = new Set<string>();

        // Admin
        if (this.auth.isAdmin()) {
            statuses.add('onboarding');
            statuses.add('active');
            statuses.add('terminated');
            statuses.add('onLeave');
        }

        return Array.from(statuses);
    }
}
